export const tratonPreset = {
	semantic: {
		primary: {
			50: '#EDF6F8',
			100: '#DAEEF1',
			200: '#B2DBE1',
			300: '#8DCAD3',
			400: '#66B8C4',
			500: '#46A6B4',
			600: '#378490',
			700: '#29626B',
			800: '#1B4046',
			900: '#0E2225',
			950: '#071112',
		},
		colorScheme: {
			light: {
				primary: {
					background: '{surface.50}',
				},
				surface: {
					50: '#F6F8F8',
					100: '#EDF1F2',
					200: '#DCE4E5',
					300: '#C7D4D6',
					400: '#B6C6C9',
					500: '#90A8AD',
					600: '#68878D',
					700: '#4C6367',
					800: '#303E41',
					900: '#111717',
					950: '#040606',
				},
			},
			dark: {
				content: {
					background: '{surface.800}',
				},
				surface: {
					50: '#F6F8F8',
					100: '#EDF1F2',
					200: '#DCE4E5',
					300: '#C7D4D6',
					400: '#B6C6C9',
					500: '#90A8AD',
					600: '#68878D',
					700: '#4C6367',
					800: '#303E41',
					900: '#111717',
					950: '#040606',
				},
			},
		},
	},
};
